import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout";
import type { ButtonProps } from "@mui/material";
import { Button } from "@mui/material";
import type { FC } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import BookOfferDialog from "../../eCommerce/BookOfferDialog";
import type { ECommerceOfferResponse } from "../../eCommerce/eCommerceApi";
import type { ECommerceOfferProductWithNames } from "../../eCommerce/eCommerceTypes";
import { useBookOffer } from "../../eCommerce/useBookOffer";

type ECommerceOffer = Pick<ECommerceOfferResponse, "id" | "name"> & {
  readonly products: ECommerceProduct[];
};

type ECommerceProduct = Pick<ECommerceOfferProductWithNames, "id" | "price" | "currency">;

type BookOfferButtonProps = {
  offer: ECommerceOffer;
} & ButtonProps;

export const BookOfferButton: FC<BookOfferButtonProps> = ({ offer, sx, ...buttonProps }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const navigate = useNavigate();

  const { book } = useBookOffer(offer);

  const handleBook = async (note: string) => {
    await book(note, offer.products);
    navigate(`/orders/${offer.id.value}`);
  };

  return (
    <>
      <Button
        {...buttonProps}
        variant="contained"
        color="primary"
        startIcon={<ShoppingCartCheckoutIcon />}
        disableElevation
        sx={{ borderRadius: 2, ...sx }}
        onClick={() => setDialogOpen(true)}
      >
        Zarezerwuj
      </Button>
      <BookOfferDialog
        offerName={offer.name}
        open={dialogOpen}
        onCancel={() => setDialogOpen(false)}
        onConfirm={handleBook}
      />
    </>
  );
};
